import { render } from "./ListSubCommunityView.vue?vue&type=template&id=c3880824"
import script from "./ListSubCommunityView.vue?vue&type=script&lang=js"
export * from "./ListSubCommunityView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__